var map = {
	"./autumn-top.png": "dea5",
	"./autumn.jpg": "fa7e",
	"./bak/autumn.jpg": "22e1",
	"./bak/autumn1.jpg": "114f",
	"./bak/px.png": "763b",
	"./bak/tmxCarGit.png": "ffff",
	"./bak/yb.png": "aa7e",
	"./checked.png": "0ae5",
	"./chunjie.jpg": "70e9",
	"./cured_meat.png": "89c5",
	"./cy.jpg": "0e61",
	"./dark.png": "ebd1",
	"./dw_1.png": "173d",
	"./dw_2.png": "38bd",
	"./dw_3.png": "f158",
	"./dw_4.png": "34dc",
	"./dw_5.png": "3757",
	"./dw_6.png": "13f2",
	"./dw_7.png": "8044",
	"./dwbg.png": "eaa5",
	"./jy-img.png": "b939",
	"./liwu.gif": "e8e7",
	"./logo.png": "cae4",
	"./milk.png": "8a28",
	"./mooncake.png": "f63f",
	"./noodles.png": "886c",
	"./produce.png": "65b2",
	"./px.jpg": "1684",
	"./px.png": "baf7",
	"./px1.png": "a53c",
	"./spring.png": "ab1c",
	"./teapot.png": "4387",
	"./text_bg.png": "a064",
	"./wash.png": "c287",
	"./welfare_bg.jpg": "d39c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7973";